import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SquareIcon from "@mui/icons-material/Square";
import { Grid, Tooltip, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import React, { useEffect, useRef, useState } from "react";
import { useGetList } from "react-admin";
import { useForm } from "react-hook-form";
import CustomDateField from "../../unit/CustomDateField";
import CustomSelect from "../../unit/forms/CustomSelect";
import CustomTextInput from "../../unit/forms/CustomTextInput";
import useNotify from "../../unit/useNotify";
import { styled } from "@mui/material/styles";
import sendRequest from "../../dataProvider/sendRequest";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";
import { Print } from "@mui/icons-material";
function useFormCustom() {
  const { register, ...rest } = useForm();
  return {
    register,
    ...rest,
  };
}

function getSquaredIconColor(
  optionLabel: any,
  defaultValue: any,
  bbvalue: any
) {
  const toComparableNumber = (value: any) => {
    if (value == null || value == undefined) {
      return NaN;
    }

    return parseFloat(String(value).trim().replace(/,/g, ""));
  };

  let iconColor = "grey";
  if (
    optionLabel.includes("Ontime") ||
    optionLabel.includes("Rental On-Time Months")
  ) {
    defaultValue = toComparableNumber(defaultValue);
    bbvalue = toComparableNumber(bbvalue);
    optionLabel = "Maximum";
  }

  if (
    optionLabel.includes("Latest Date") ||
    optionLabel.includes("Earliest Date")
  ) {
    optionLabel = "Maximum";
  }
  if (bbvalue == "" || bbvalue == null || bbvalue == "null") {
    iconColor = "grey";
    return iconColor;
  }
  if (bbvalue == "Pass" || isEquivalentValue(defaultValue, bbvalue)) {
    iconColor = "green";
  } else {
    if (bbvalue != "") {
      if (optionLabel.includes("Min")) {
        bbvalue = toComparableNumber(bbvalue);
        defaultValue = toComparableNumber(defaultValue);
        if (bbvalue > defaultValue) {
          iconColor = "green";
        } else {
          iconColor = "red";
        }
      } else if (optionLabel.includes("Max")) {
        bbvalue = toComparableNumber(bbvalue);
        defaultValue = toComparableNumber(defaultValue);
        if (bbvalue < defaultValue) {
          iconColor = "green";
        } else {
          iconColor = "red";
        }
      } else {
        iconColor = "red";
      }
    } else if (bbvalue == "") {
      iconColor = "grey";
    }
  }

  return iconColor;
}

function isEquivalentValue(leftValue: any, rightValue: any) {
  const normalizeValue = (value: any) => {
    if (value == null || value == undefined) {
      return "";
    }
    return String(value).trim();
  };

  const normalizedLeft = normalizeValue(leftValue);
  const normalizedRight = normalizeValue(rightValue);

  const leftNumeric = parseFloat(normalizedLeft.replace(/,/g, ""));
  const rightNumeric = parseFloat(normalizedRight.replace(/,/g, ""));
  const leftIsNumeric =
    normalizedLeft !== "" &&
    !Number.isNaN(leftNumeric) &&
    /^-?[\d,.]+$/.test(normalizedLeft);
  const rightIsNumeric =
    normalizedRight !== "" &&
    !Number.isNaN(rightNumeric) &&
    /^-?[\d,.]+$/.test(normalizedRight);

  if (leftIsNumeric && rightIsNumeric) {
    return leftNumeric === rightNumeric;
  }

  return normalizedLeft === normalizedRight;
}

const RequirementFieldRecord = ({ ...props }) => {
  const { appId, item, requirementId } = props;

  let defaultIconColor = getSquaredIconColor(
    item.optionLabel,
    item.sValue,
    item.bb_value
  );

  const [iconColor, setIconColor] = useState(defaultIconColor);

  const handleInputChange = (event: any) => {
    let optionLabel = item.optionLabel;
    let defaultValue = item.sValue;
    let bbvalue = event.target.value;
    let iconColor2 = getSquaredIconColor(optionLabel, defaultValue, bbvalue);
    setIconColor(iconColor2);
  };

  useEffect(() => {
    let parentColor = changeParentIconColor(appId, requirementId);
    let circleIcon = document.querySelectorAll<SVGElement>(
      "#requirementForm_" + appId + " .circleIcons_" + requirementId
    );
    for (let i = 0; i < circleIcon.length; i++) {
      circleIcon[i].style.color = parentColor;
    }
  }, [iconColor]);

  let className = props.className || "";
  if (item?.cavalue && !isEquivalentValue(item?.cavalue, item?.bb_value)) {
    className += "vsClass";
  }
  return (
    <Grid container display="flex" gap={1}>
      {/* {item?.cavalue}--{item?.bb_value}-- */}
      <Grid item gap={1} sx={{ paddingTop: "15px" }}>
        <SquareIcon
          sx={{ color: iconColor }}
          className={`squareIcons_` + requirementId}
        />
      </Grid>
      <Grid
        item
        xs={7}
        gap={1}
        className="hm-text"
        sx={{
          fontSize: "0.875rem",
          color: "gray",
          fontFamily: "Proxima Nova",
          paddingTop: "18px",
          "& a": { color: "#00CCB1" },
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: item.sLenderTitle }}
          style={{
            whiteSpace: "pre-line",
          }}
        ></div>
      </Grid>
      <Grid item xs={2} gap={1} sx={{ paddingTop: "18px" }} className="hm-text">
        {/* <HeaderLabelTitle title={item.optionLabel} /> */}
        {item.optionLabel}
        {/* (className:{className})(cavalue:{item.cavalue}) */}
      </Grid>
      <Grid item xs={1} gap={1} sx={{ paddingTop: "18px" }}>
        <CustomTextInput
          name={`defaultValue_` + item.id}
          className={className + `hm-text defaultValue_` + item.id}
          reqId={item.id}
          value={item.sValue}
          size="small"
          type="label"
        />
      </Grid>
      <Grid item xs={1} gap={1}>
        <FormControl variant="standard" sx={{ m: 0, minWidth: 100 }}>
          <RequirementBBField
            id={`bbValue_` + item.id + "_" + item.optionId}
            name={`bbValue_` + item.id + "_" + item.optionId}
            className={className + " bbValue"}
            type={item.optionType}
            cavalue={
              item.cavalue && className.includes("vsClass") ? item.cavalue : ""
            }
            defaultValue={item.bb_value == "null" ? "" : item.bb_value}
            onChange={handleInputChange}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};
const RequirementBBField = ({ ...props }) => {
  const { id, name, reqId, type, optionId, onChange } = props;
  let defaultValue = props.defaultValue;
  if (
    defaultValue == null ||
    defaultValue == undefined ||
    defaultValue == "null"
  ) {
    defaultValue = "";
  }
  const [inputValue, setInputValue] = useState(defaultValue);
  const defautOptionList = [
    { label: "Select", value: "" },
    { label: "Pass", value: "Pass" },
    { label: "Fail", value: "Fail" },
  ];

  if (type == "select") {
    return (
      <CustomSelect
        {...props}
        size="small"
        id={id}
        variant="outlined"
        optionlist={defautOptionList}
        value={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value != "") {
            setInputValue(e.target.value);
          } else {
            setInputValue("");
          }
          if (onChange) {
            onChange(e);
          }
        }}
      />
    );
  } else if (
    type == "number" ||
    type == "numeric" ||
    type == "string" ||
    type == "text"
  ) {
    return (
      <CustomTextInput {...props} id={id} size="small" variant="outlined" />
    );
  } else if (type == "date") {
    return (
      <CustomDateField {...props} id={id} size="small" variant="outlined" />
    );
  } else {
    return (
      <CustomTextInput {...props} id={id} size="small" variant="outlined" />
    );
  }
};

const changeParentIconColor = (appId: any, requirementId: any) => {
  let squareIcons = document.querySelectorAll(
    "#requirementForm_" + appId + " .squareIcons_" + requirementId
  );
  let allGreen = true;
  let allRed = true;
  let allGrey = true;
  let greenCount = 0;
  let redCount = 0;
  let greyCount = 0;

  for (let i = 0; i < squareIcons.length; i++) {
    const computedStyle = window.getComputedStyle(squareIcons[i]);
    const color = computedStyle.getPropertyValue("color");
    if (color == "red" || color == "rgb(255, 0, 0)") {
      redCount++;
    }
    if (color == "green" || color == "rgb(0, 128, 0)") {
      greenCount++;
    }
    if (color == "grey" || color == "rgb(128, 128, 128)") {
      greyCount++;
    }
  }

  if (greyCount > 0) {
    return "grey";
  }
  if (redCount > 0) {
    return "red";
  }
  if (greenCount > 0) {
    return "green";
  }

  return "grey";
};

const MainSection = styled("article")({
  paddingTop: "10px",
  paddingBottom: "0px",
  height: `calc(100vh - 120px - 60px - 110px - 50px - 10px)`,
  overflowY: "auto",
  backgroundColor: "#fff",
});

const ApplicationUnderwritingData = ({ ...props }) => {
  const appId = props.appId;
  const record = props?.record;
  const { successNotify, errorNotify } = useNotify();
  const [showDisabledTip, setShowDisabledTip] = useState(false);

  if (appId === "" || appId === undefined) {
    return <>Underwriting Data Missing Application ID...</>;
  }

  const [underwritingData, setUnderwritingData] = useState<any[] | undefined>(
    undefined
  );
  const reqUrl = "applications/requirements/" + appId;
  const { data, total, error } = useGetList(reqUrl);

  useEffect(() => {
    setUnderwritingData(data);
  }, [appId, data]);

  const isMounted = useRef(false);
  const renderCountRef = useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      renderCountRef.current += 1;
    }
  });

  if (error) {
    return <Typography color="error">Error loading data</Typography>;
  }
  if (!total) {
    return <Typography>Loading Underwriting Data</Typography>;
  }

  const SubmitUnderwritingForm = async () => {
    let submitData: { [key: string]: any } = {};
    var elements = document.querySelectorAll(
      "#requirementForm_" + appId + " [name^='bbValue_']"
    );
    elements.forEach(function (el) {
      const inputElement = el as HTMLInputElement;
      submitData[inputElement.name] = inputElement.value;
    });

    const reqUrl = "applications/requirements/save";
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: submitData,
    });
    if (response && response.status == "200") {
      successNotify("Data saved successfully");
      if (props?.cb) {
        let otherData = {
          requirementSaved: "yes",
        };
        props.cb("Initial Review", otherData);
      }
    } else {
      errorNotify(response?.message || "Data not saved!");
    }
  };
  const handlePrintUnderwritingData = () => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      [class*="printBody-underwriting-${appId}"],
      [class*="printBody-underwriting-${appId}"] * {
        visibility: visible;
        overflow: visible !important;
        max-height: none !important;
        height: auto !important;
      }
      [class*="printBody-underwriting-${appId}"]{
        position: absolute;
        left: 0;
        top: 0;
        width:100% !important;
      }
      [class*="printBody-underwriting-${appId}"] article{
          width:98% !important;
          max-width:98% !important;
      }
          [class*="printBody-underwriting-${appId}"] article input{
            width:80px !important;
            border:1px solid red;
          }
    }
  `;
    document.head.appendChild(style);

    window.print();
    setTimeout(() => {
      document.head.removeChild(style);
    }, 100);
  };
  return (
    <>
      {underwritingData && (
        <>
          <Grid
            container
            sx={{
              width: "100%",
              pt: 1,
              pm: 1,
              pb: 1,
            }}
          >
            <Grid item xs={7}>
              <HmPageHeaderTitle title={"Underwriting Summary"} />
            </Grid>
            <Grid item xs={5} sx={{ pr: 0 }}>
              {props?.appStatus == "Initial Review" ||
              props?.appStatus == "New" ||
              props?.appStatus == "restart" ||
              props?.appStatus == "Check" ? (
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  sx={{ float: "right", width: "120px" }}
                  onClick={SubmitUnderwritingForm}
                >
                  Save
                </Button>
              ) : (
                <Tooltip
                  title="Changes cannot be saved. Application status is not 'Initial Review' or 'Final Review'."
                  placement="left"
                  open={showDisabledTip}
                  PopperProps={{
                    style: { zIndex: 9999 },
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      position: "relative",
                      float: "right",
                    }}
                    onMouseEnter={() => setShowDisabledTip(true)}
                    onMouseLeave={() => setShowDisabledTip(false)}
                  >
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      sx={{
                        float: "right",
                        width: "120px",
                      }}
                      disabled
                    >
                      Save
                    </Button>
                  </span>
                </Tooltip>
              )}
              {/* Right Icon Print */}
              {/* <Print
                sx={{
                  ml: "auto",
                  float: "right",
                  mr: 2,
                  mt: 1,
                  cursor: "pointer",
                  color: "#1976d2",
                  "&:hover": { color: "#0b4f94ff" },
                }}
                onClick={handlePrintUnderwritingData}
              /> */}
            </Grid>
          </Grid>
          <MainSection
            id="mainsection-underwriting"
            className={`printBody-underwriting-${appId} app-summary-bodysection`}
          >
            <div id={"requirementForm_" + appId} className="underwriting-form">
              {underwritingData?.map((requirement, index) => (
                <Accordion key={index} sx={{ width: "100%" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <CircleIcon
                      className={`circleIcons_` + requirement.id}
                      sx={{ mr: 1, color: "grey" }}
                    />
                    <HeaderLabelTitle title={requirement.title} />
                  </AccordionSummary>
                  <AccordionDetails sx={{ pl: 5 }}>
                    {requirement.requirementDetail.map(
                      (item: any, index: number) => (
                        <RequirementFieldRecord
                          appId={appId}
                          item={item}
                          requirementId={requirement.id}
                          key={`reqlist_` + item.id}
                        />
                      )
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </MainSection>
        </>
      )}
    </>
  );
};

export default ApplicationUnderwritingData;
